// src/components/ComprovanteVenda.jsx
import React, { forwardRef } from 'react';

export const ComprovanteVenda = forwardRef(({ dados, loja }, ref) => {
  
  // SE NÃO TIVER DADOS, RENDERIZA UMA DIV VAZIA MAS COM A REF (Isso corrige o bug de não imprimir)
  if (!dados) {
    return <div ref={ref} className="hidden"></div>;  
}

  const titulo = dados.tipo === 'orcamento' ? 'ORÇAMENTO' : 'COMPROVANTE DE VENDA';

  return (
    <div ref={ref} className="w-[80mm] p-4 bg-white text-black font-mono text-[12px] leading-tight">
      
      {/* --- CABEÇALHO DA LOJA --- */}
      <div className="text-center mb-3 border-b border-black border-dashed pb-2">
        <h2 className="font-bold text-sm uppercase">{loja?.nome || "LOJA GESTORPRO"}</h2>
        <p>{loja?.endereco || "Endereço da Loja, 000"}</p>
        <p>{loja?.telefone || "(00) 0000-0000"}</p>
        <p className="mt-1 text-[10px]">{new Date().toLocaleString()}</p>
      </div>

      {/* --- AVISO NÃO FISCAL --- */}
      <div className="text-center mb-3 font-bold border border-black p-1">
        <p>*** NÃO É DOCUMENTO FISCAL ***</p>
        <p className="text-[10px] font-normal">Controle Interno / Conferência</p>
      </div>

      {/* --- TÍTULO DA OPERAÇÃO --- */}
      <div className="text-center font-bold mb-2 text-sm">
        {titulo} #{dados.id ? String(dados.id).slice(0, 6) : '000'}
      </div>

      {/* --- LISTA DE PRODUTOS --- */}
      <table className="w-full mb-2">
        <thead>
          <tr className="border-b border-black">
            <th className="text-left w-2">Qtd</th>
            <th className="text-left">Item</th>
            <th className="text-right">R$</th>
          </tr>
        </thead>
        <tbody>
          {dados.itens?.map((item, index) => (
            <tr key={index}>
              <td className="align-top">{item.quantidade}x</td>
              <td className="uppercase align-top pr-1">
                {item.nome}
              </td>
              <td className="text-right align-top font-bold">
                {(item.quantidade * (item.preco || item.precoUnitario || 0)).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* --- TOTAIS --- */}
      <div className="border-t border-black border-dashed pt-2 mb-4">
        <div className="flex justify-between text-sm">
          <span>SUBTOTAL:</span>
          <span>R$ {dados.subtotal?.toFixed(2)}</span>
        </div>
        
        {dados.desconto > 0 && (
          <div className="flex justify-between text-sm">
            <span>DESCONTO:</span>
            <span>- R$ {dados.desconto?.toFixed(2)}</span>
          </div>
        )}

        <div className="flex justify-between font-bold text-lg mt-2">
          <span>TOTAL:</span>
          <span>R$ {dados.total?.toFixed(2)}</span>
        </div>
      </div>

      {/* --- FORMA DE PAGAMENTO --- */}
      {dados.tipo !== 'orcamento' && (
        <div className="mb-4 border-b border-black border-dashed pb-2">
          <p className="font-bold">Pagamento:</p>
          <p className="uppercase">{dados.metodoPagamento || "Não informado"}</p>
        </div>
      )}

      {/* --- RODAPÉ --- */}
      <div className="text-center text-[10px] mt-4">
        <p>Obrigado pela preferência!</p>
        <p className="mt-1 font-bold">*** NÃO VALE COMO RECIBO ***</p>
        <p>Sistema GestorPro</p>
      </div>
    </div>
  );
});